import { action } from "@ember/object"
import Component from "@glimmer/component"
import styles from "./item.module.css"

export default class Item extends Component {
  styles = styles

  @action
  onClick() {
    if (this.args.clickAction) {
      this.args.clickAction()
    }
  }
}
